







































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import pxButton from '@/dex-shared/components/px-button.vue';
import AdminListModel from '@/models/AdminListModel';

export default Vue.extend({
  components: {
    pxButton,
  },

  props: {
    shownInView: {
      type: Boolean,
      required: true,
    },
    listId: {
      type: Number,
      required: true,
    },
  },

  data: function() {
    return {
      group: '',
      pullingItems: false,
      firstSearch: true,
      updatable: false,
    };
  },

  computed: {
    ...mapGetters({
      listById: 'listById',
    }),
    list(): AdminListModel {
      return this.listById(this.listId);
    },
    name(): string {
      return this.list.name;
    },
    description: {
      get(): string {
        return this.list.description;
      },
      set(value: string) {
        this.updateList('description', value);
      },
    },
    author: {
      get(): string {
        return this.list.author;
      },
      set(value: string) {
        this.updateList('author', value);
      },
    },
    type: {
      get(): string {
        return this.list.type || 'EXERCISES';
      },
      set(value: string) {
        this.updateList('type', value);
      },
    },
    publishDate: {
      get(): string {
        return this.list.publishDate && this.list.publishDate.split('T')[0];
      },
      set(value: string) {
        this.updateList('publishDate', value);
      },
    },
    __types: {
      get(): string[] {
        return AdminListModel.__types;
      },
    },
  },

  methods: {
    alterName(e: Event) {
      const name = (e.target as HTMLInputElement).value;
      this.updateList('name', name);
      this.$emit('title-filled', name.length != 0);
    },
    setAuthor(e: Event) {
      const author = (e.target as HTMLInputElement).value;
      this.updateList('author', author);
    },
    setPublishDate(e: Event) {
      const publishDate = (e.target as HTMLInputElement).value;
      this.updateList('publishDate', publishDate);
    },
    datePlaceholder(): string {
      const today = new Date();
      return today.toISOString().split('T')[0];
    },
    updateList(prop: string, value: any) {
      this.$store.commit('UPDATE_ENTITY_PROP', {
        id: this.listId,
        entity: 'lists',
        propToUpdate: prop,
        value,
      });
    },
    async pullItemsByGroup() {
      this.pullingItems = true;
      try {
        await this.$store.dispatch('CREATE_ITEMS_FROM_TAG', {
          tag: this.group,
          listId: this.listId,
        });
      } catch (e) {
        alert(
          `Algo deu errado. Envie essas informações para os desenvolvedores: ${e}`,
        );
      }
      this.pullingItems = false;
    },
  },
});
